import { createSelector } from "reselect";
import { AppStateLogin } from "../auth";
import { AppStateHealthCheck } from "../healthCheck";
import {
  AppsStateOrganization,
  NodeType,
  OrganizationNode,
} from "../organization";
import { nodeById } from "../organization/selectors";
import { RoleType } from "../users";
import { IAppState } from "../types";
import { AppStateUserProfile } from "./";

export const allowFallFPrevention = createSelector(
  (state: IAppState): AppStateUserProfile => state.userProfile,
  (state: IAppState): OrganizationNode[] => state.organization.nodes,
  (userProfile, nodes) => {
    const userNode = nodeById(nodes, userProfile.baseNodeId);
    return (
      (userProfile.roleName === RoleType.ADMIN ||
        userProfile.roleName === RoleType.VIEWER) &&
      userNode !== undefined &&
      (userNode.type === NodeType.Department ||
        userNode.type === NodeType.Building)
    );
  }
);

export const authReady = createSelector(
  (state: IAppState): AppStateLogin => state.auth,
  (auth) => {
    return auth.isAuthenticated; //&& userProfile.isLoading == false && organization.isLoading === false;
  }
);

export const allowToSignOut = createSelector(
  (state: IAppState): AppStateLogin => state.auth,
  (state: IAppState): AppStateUserProfile => state.userProfile,
  (state: IAppState): AppsStateOrganization => state.organization,
  (state: IAppState): AppStateHealthCheck => state.healthCheck,
  (auth, userProfile, organization, healthCheck) => {
    return (
      auth.isAuthenticated &&
      userProfile.isLoading === false &&
      organization.isLoading === false &&
      healthCheck.subscribeData !== undefined
    );
  }
);

export const profileReady = createSelector(
  (state: IAppState): AppStateLogin => state.auth,
  (state: IAppState): AppStateUserProfile => state.userProfile,
  (auth, userProfile) => {
    return auth.isAuthenticated && userProfile.isLoading === false;
  }
);
